// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"472":"b5664c88","552":"ce47c81d","592":"3a368bad","940":"5758b6ac","972":"8a1c7132"}[chunkId] + ".chunk.js";
};